export const appConfig = {
    baseUrl: process.env.REACT_APP_API_URL || "http://172.184.199.125/",
    tokenName: "auth_token"
}

